import * as yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { TextField, Typography,styled} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import {API_URL} from '../constant';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../context/logincontext';
import ConfirmDialog from '../components/confirmDialog';
// ----------------------------------------------------------------------

const phoneRegExp = /^([0-9]){10}?$/
const validationSchema = yup.object({
  insurer_name: yup.string().required('field cannot be empty'),
  address: yup.string().required('field cannot be empty'),
  // point_of_contact: yup.string().required('field cannot be empty'),
  mobile: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('field cannot be empty'),
});

export default function AddInsurer() {
  let {id} = useParams()
  const context = useContext(LoginContext)
  const navigate = useNavigate();
  const[userData,setUserData]=useState(context.user);
  const [formvalue, setFormValue] = useState({})
  const [open, setOpen] = useState(false)
  id = id?id:0

  const formik = useFormik({
    initialValues: {
      insurer_name: '',
      poc:'',
      address:'',
      mobile:'',
      user_id: userData.user_id
    },
     validationSchema,
    onSubmit: async (value) => {
      setFormValue({...value})
      setOpen(true)
    },
  });
  async function submitForm(value) {
    const response = await axios.put(`${API_URL}/insurer/${id}`,value);
    if(response.data.status === 'success') {
      navigate('/dashboard/insurers');
    }
  }
  const getData = async() =>{
    const response = await axios.get(`${API_URL}/insurer/${id}`);
    if(response.data.status === 'success'){
      const data = response?.data?.data
      formik.setFieldValue('insurer_name',data?.insurer_name)
      formik.setFieldValue('poc',data?.poc)
      formik.setFieldValue('address',data?.address)
      formik.setFieldValue('mobile',data?.mobile)
    }
  }

  useEffect(() => {
    if(id){
      getData()
    }
  },[]); 
  const submitFormValue = () => {
    submitForm(formvalue)
    setOpen(false);
  };

  const closeDialog = () => {
    setOpen(false);
  }; 
  return (
    <div>
      <ConfirmDialog open={open} onClose={closeDialog} submit={submitFormValue} close={closeDialog} />
      <Typography style={{paddingLeft:'20px'}} variant="h4" gutterBottom>
         {id ? 'Edit Insurer' : 'Add Insurer' }
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ flexGrow: 1, p: 2 }}>
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={11} sm={6}>
          <TextField
            autoComplete='off'
            fullWidth
            name="insurer_name"
            type={'text'}
            label="Insurer Name"
            value={formik.values.insurer_name}
            onChange={formik.handleChange}
            error={formik.touched.insurer_name && Boolean(formik.errors.insurer_name)}
            helperText={formik.touched.insurer_name && formik.errors.insurer_name}
          />
          </Grid>
          <Grid item xs={11} sm={6}>
          <TextField
            autoComplete='off'
            fullWidth
            name="poc"
            type={'text'}
            label="Point Of Contact"
            value={formik.values.poc}
            onChange={formik.handleChange}
            error={formik.touched.poc && Boolean(formik.errors.poc)}
            helperText={formik.touched.poc && formik.errors.poc}
          />
          </Grid>
          <Grid item xs={11} sm={6}>
          <TextField
            autoComplete='off'
            fullWidth
            name="address"
            type={'text'}
            label="Address"
            value={formik.values.address}
            onChange={formik.handleChange}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
          />
          </Grid>
          <Grid item xs={11} sm={6}>
          <TextField
            autoComplete='off'
            fullWidth
            name="mobile"
            type={'number'}
            label="Mobile Number"
            value={formik.values.mobile}
            onChange={formik.handleChange}
            error={formik.touched.mobile && Boolean(formik.errors.mobile)}
            helperText={formik.touched.mobile && formik.errors.mobile}
          />
          </Grid>
        </Grid>
        </Box>
        <Box sx={{ m: 2 }}>
          <Grid container spacing={2} justifyContent='center'>
            <Grid item xs={8} sm={6}>
            <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={formik.isSubmitting}
            >
            Submit
            </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </form>
    </div>
  );
}